// extracted by mini-css-extract-plugin
export default {"video-player":"lylR5sGPXm4fpDoZXrFu","videoPlayer":"lylR5sGPXm4fpDoZXrFu"};